import { Component, OnInit } from '@angular/core';
import { AudioPlayerService } from '../../Services/audioPlayer.service';

@Component({ standalone: false, selector: 'office-audio-player', template: `` })
export class AudioPlayerComponent implements OnInit {
	public audioSuspended: string = null;
	private _clickListener = false;

	constructor(private _audioPlayerService: AudioPlayerService) {}

	ngOnInit() {
		this._audioPlayerService.onSuspended.subscribe((src) => {
			this.audioSuspended = src;

			if (this._clickListener) {
				if (src === null) document.removeEventListener('click', this.windowClicked);

				return;
			}

			this._clickListener = true;
			document.addEventListener('click', this.windowClicked);
		});
	}

	windowClicked = () => {
		this._clickListener = false;
		document.removeEventListener('click', this.windowClicked);

		this._audioPlayerService.play(this.audioSuspended);
		this.audioSuspended = null;
	};
}
